module.exports = __webpack_public_path__ + "static/media/warningIcon.330d303a.svg";